import { useRef, useState, useEffect } from "react";
import useDrawerMenu from "../hooks/useDrawerMenu";


const Header = () => {
  const drawerRef = useRef(null);
  useDrawerMenu(drawerRef);

  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <>
      {/* Header 1 */}
      <sticky-header data-sticky-type="always">
        <header className="header-1 header-floating glass-effect">
          <div className="container-fluid">
            <div className="header-grid">
              <a className="header-logo" href="/" aria-label="Consulo">
                <img
                  src="assets/img/logo.svg"
                  alt="Aarogya OPD Logo"
                  width={189}
                  height={32} className="max-md:h-[50px]"
                />
              </a>
              <drawer-menu>
                <nav ref={drawerRef} className="header-nav drawer-menu">
                  <div className="lg:hidden header-nav-headings">
                    <a
                      className="header-logo"
                      href="/"
                      aria-label="Consulo"
                    >
                      <img
                        src="assets/img/logo.svg"
                        alt="Aarogya OPD Logo"
                        width={189}
                        height={32}
                        loading="lazy"
                      />
                    </a>
                    <drawer-opener
                      className="svg-wrapper menu-close"
                      data-drawer=".drawer-menu"
                    >
                      <svg
                        width="30px"
                        height="30px"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M8.00386 9.41816C7.61333 9.02763 7.61334 8.39447 8.00386 8.00395C8.39438 7.61342 9.02755 7.61342 9.41807 8.00395L12.0057 10.5916L14.5907 8.00657C14.9813 7.61605 15.6144 7.61605 16.0049 8.00657C16.3955 8.3971 16.3955 9.03026 16.0049 9.42079L13.4199 12.0058L16.0039 14.5897C16.3944 14.9803 16.3944 15.6134 16.0039 16.0039C15.6133 16.3945 14.9802 16.3945 14.5896 16.0039L12.0057 13.42L9.42097 16.0048C9.03045 16.3953 8.39728 16.3953 8.00676 16.0048C7.61624 15.6142 7.61624 14.9811 8.00676 14.5905L10.5915 12.0058L8.00386 9.41816Z"
                          fill="currentColor"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12ZM3.00683 12C3.00683 16.9668 7.03321 20.9932 12 20.9932C16.9668 20.9932 20.9932 16.9668 20.9932 12C20.9932 7.03321 16.9668 3.00683 12 3.00683C7.03321 3.00683 3.00683 7.03321 3.00683 12Z"
                          fill="currentColor"
                        />
                      </svg>
                    </drawer-opener>
                  </div>
                  <ul className="header-menu list-unstyled">
                    <li className="nav-item">
                      <a className="menu-link menu-link-main" href="/">
                        Home
                      </a>
                    </li>
                    <li className="nav-item">
                      <a className="menu-link menu-link-main" href="/plans">
                        Plans
                      </a>
                    </li>
                    <li className="nav-item nav-item-static">
                      <a
                        className="menu-link menu-link-main menu-accrodion"
                        href="#"
                      >
                        Terms & Polices
                        <svg
                          width={10}
                          height={5}
                          viewBox="0 0 10 5"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M5 5L0 0H10L5 5Z" fill="currentColor" />
                        </svg>
                      </a>
                      <div className="header-megamenu header-submenu menu-absolute submenu-color">
                        <ul className="list-unstyled">
                          <li className="nav-item max-md:!pb-0">
                            <div
                              className="menu-link heading fw-300 max-md:!hidden"
                            >
                              POLICIES
                            </div>
                            <ul className="reset-submenu list-unstyled submenu-color">
                              <li className="nav-item max-md:!px-0">
                                <a className="menu-link" href="/term-of-use">
                                  <div className="heading text-20 fw-600 max-md:!text-[16px] max-md:!font-normal">
                                    Terms & Conditions
                                  </div>
                                </a>
                              </li>
                              <li className="nav-item max-md:!px-0">
                                <a className="menu-link" href="/shipping-delivery-policy">
                                  <div className="heading text-20 fw-600 max-md:!text-[16px] max-md:!font-normal">
                                    Shipping & Delivery
                                  </div>
                                </a>
                              </li>
                              <li className="nav-item max-md:!px-0">
                                <a className="menu-link" href="/privacy-policy">
                                  <div className="heading text-20 fw-600 max-md:!text-[16px] max-md:!font-normal">
                                    Privacy Policy
                                  </div>
                                </a>
                              </li>
                              <li className="nav-item max-md:!px-0">
                                <a className="menu-link" href="/cancellation-policy">
                                  <div className="heading text-20 fw-600 max-md:!text-[16px] max-md:!font-normal">
                                    Cancellation Policy
                                  </div>
                                </a>
                              </li>
                            </ul>
                          </li>
                          <li className="nav-item  max-md:!hidden">
                            <div
                              className="menu-link heading fw-300"
                            >
                              AAROGYA
                            </div>
                            <ul className="reset-submenu list-unstyled submenu-color">
                              <li className="nav-item">
                                <div
                                  className="menu-link megamenu-image-wrap"
                                >
                                  <picture>
                                    <img
                                      src="assets/img/menu/1.jpg"
                                      width={1000}
                                      height={668}
                                      loading="lazy"
                                      alt="Hero Image"
                                    />
                                  </picture>
                                </div>
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li className="nav-item">
                      <a className="menu-link menu-link-main" href="/contact">
                        Contact Us
                      </a>
                    </li>
                    <li className="nav-item md:hidden">
                      <a className="menu-link menu-link-main" href="login.html">
                        Customer Login <i class="fa-solid fa-arrow-right"></i>
                      </a>
                    </li>
                    <li className="nav-item md:hidden">
                      <a className="menu-link menu-link-main" href="https://portal.aarogyaopd.com/">
                        Agent / Leader Login <i class="fa-solid fa-arrow-right"></i>
                      </a>
                    </li>
                  </ul>
                </nav>
              </drawer-menu>
              <div className="header-actions flex items-center">

                <div
                  ref={dropdownRef}
                  className="relative !hidden lg:!inline-flex"
                >
                  {/* Login Button */}
                  <div
                    aria-label="Login"
                    onClick={() => setOpen(!open)}
                    className="button button--secondary button--slim flex items-center gap-2 cursor-pointer"
                  >
                    Login
                    <span className="svg-wrapper">
                      <svg
                        className="icon-20"
                        width={20}
                        height={20}
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M13.3365 7.84518L6.16435 15.0173L4.98584 13.8388L12.158 6.66667H5.83652V5H15.0032V14.1667H13.3365V7.84518Z"
                          fill="currentColor"
                        />
                      </svg>
                    </span>
                  </div>

                  {/* Dropdown */}
                  <div
                    className={`absolute mt-[14px] right-0 top-full w-[180px] bg-white border rounded-md shadow-lg overflow-hidden transition duration-200 ${open ? "opacity-100 visible" : "opacity-0 invisible"
                      }`}
                  >
                    <a
                      href="/login.html" target="_blank"
                      className="px-4 py-2 text-sm text-[#1c2539] font-medium hover:bg-gray-100 flex items-center justify-between"
                    >
                      Customer Login <i class="fa-solid fa-chevron-right"></i>
                    </a>

                    <a
                      href="https://portal.aarogyaopd.com/" target="_blank"
                      className="px-4 py-2 text-sm text-[#1c2539] font-medium hover:bg-gray-100 flex items-center justify-between"
                    >
                      Agent / Leader Login <i class="fa-solid fa-chevron-right"></i>
                    </a>
                  </div>
                </div>

                <div className="md:!hidden">
                  <drawer-opener
                    className="svg-wrapper menu-open lg:!hidden"
                    data-drawer=".drawer-menu"
                  >
                    <svg
                      width={52}
                      height={52}
                      viewBox="0 0 52 52"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle
                        cx={26}
                        cy={26}
                        r="25.5"
                        fill="white"
                        stroke="black"
                      />
                      <path
                        d="M32.5 18.2857C32.5 17.5757 31.9179 17 31.2 17H14.3C13.5821 17 13 17.5757 13 18.2857C13 18.9958 13.5821 19.5714 14.3 19.5714H31.2C31.9179 19.5714 32.5 18.9957 32.5 18.2857ZM14.3 24.7143H37.7C38.4179 24.7143 39 25.29 39 26C39 26.7101 38.4179 27.2857 37.7 27.2857H14.3C13.5821 27.2857 13 26.7101 13 26C13 25.29 13.5821 24.7143 14.3 24.7143ZM14.3 32.4286H26C26.7179 32.4286 27.3 33.0042 27.3 33.7143C27.3 34.4243 26.7179 35 26 35H14.3C13.5821 35 13 34.4243 13 33.7143C13 33.0042 13.5821 32.4286 14.3 32.4286Z"
                        fill="black"
                      />
                    </svg>
                  </drawer-opener>
                </div>
              </div>
            </div>
          </div>
        </header>
      </sticky-header>

    </>
  );
};

export default Header;
